import React from 'react';
import bem from 'utils/bem';
import { formatPrice } from 'utils/format';
import { times } from 'utils/render';
import { Skeleton } from '@mui/material';
import Text from 'components/Text';
import Details from 'components/Details';
import PurchaseItem, { PurchaseItemSkeleton } from './PurchaseItem';
import PayButton from './PayButton';
import { LinkButton } from 'components/Button';
import { useMobile } from 'utils/media';
import './index.sass';

const { block, el } = bem('purchase-teaser');
const PurchaseTeaser = ({ item }) => {
    const { isMobile } = useMobile();
    if (isMobile) { return <MobilePurchaseTeaser item={item} /> }

    const { pk, status, price, items, track } = item;
    const firstItems = items.slice(0, 2);
    const restItems = items.slice(2);
    const isDetailed = restItems.length > 0;
    return (
        <div className={ block({ 'detailed': isDetailed }) }>
            <div className={ el('left') }>
                <div className={ el('status-block') }>
                    { track && <div className={ el('tracking') }>
                        <Text>Трек-номер: { track }</Text>
                    </div> }
                    <div className={ el('pk') }>
                        <Text>{ `№${ pk }` }</Text>
                    </div>
                    { status && <div className={ el('status') }>
                        <Text>{ status }</Text>
                    </div> }
                </div>
                <div className={ el('items-block') }>
                    <div className={ el('first-items') }>
                        { firstItems.map((item, index) => <PurchaseItem key={ index } item={ item }/>) }
                    </div>
                    { isDetailed && <Details>
                        <div className={ el('rest-items') }>
                            { restItems.map((item, index) => <PurchaseItem key={ index } item={ item }/>) }
                        </div>
                    </Details> }
                </div>
            </div>
            <div className={ el('right') }>
                <div className={ el('buttons-block') }>
                    <Buttons item={ item }/>
                </div>
                <div className={ el('price-block') }>
                    <div className={ el('price') }>
                        <Text>{ formatPrice(price) }</Text>
                    </div>
                </div>
            </div>
        </div>
    );
};

const MobilePurchaseTeaser = ({item}) => {
    const { pk, status, price, items, track } = item;
    const firstItems = items.slice(0, 2);
    const restItems = items.slice(2);
    const isDetailed = restItems.length > 0;
    return (
        <div className={ block({ 'detailed': isDetailed }) }>
            <div className={ el('top') }>
                <div className={ el('status-block') }>
                    { track && <div className={ el('tracking') }>
                        <Text>Трек-номер: { track }</Text>
                    </div> }
                    <div className={ el('pk') }>
                        <Text>{ `№${ pk }` }</Text>
                    </div>
                    { status && <div className={ el('status') }>
                        <Text>{ status }</Text>
                    </div> }
                </div>
                <div className={ el('price-block') }>
                    <div className={ el('price') }>
                        <Text>{ formatPrice(price) }</Text>
                    </div>
                </div>
            </div>
            <div className={ el('bottom') }>
                <div className={ el('items-block') }>
                    <div className={ el('first-items') }>
                        { firstItems.map((item, index) => <PurchaseItem key={ index } item={ item }/>) }
                    </div>
                    { isDetailed && <Details>
                        <div className={ el('rest-items') }>
                            { restItems.map((item, index) => <PurchaseItem key={ index } item={ item }/>) }
                        </div>
                    </Details> }
                </div>
                <div className={ el('buttons-block') }>
                    <Buttons item={ item }/>
                </div>
            </div>
        </div>
    );
}

const Buttons = ({ item }) => {
    if (item.canBePaid) {
        return (
            <div className={ el('pay-button') }>
                <PayButton item={ item }/>
            </div>
        );
    }
    if (item.isDigital) {
        return <DigitalLinks item={ item }/>;
    }
};

const DigitalLinks = ({ item }) => {
    if (item.buttons.length > 0) {
        return item.buttons.map((button, index) => {
            return (
                <LinkButton key={ index } to={ button.link } mod={ button?.mod }>
                    <Text>{ button.text }</Text>
                </LinkButton>
            );
        });
    }
};


export const PurchaseTeaserSkeleton = () => {
    return (
        <div className={ block() }>
            <div className={ el('left') }>
                <div className={ el('status-block') }>
                    <div className={ el('pk') }>
                        <Text><Skeleton width={ 70 }/></Text>
                    </div>
                    <div className={ el('status') }>
                        <Text><Skeleton width={ 50 }/></Text>
                    </div>
                </div>
                <div className={ el('items-block') }>
                    <div className={ el('first-items') }>
                        { times((key) => <PurchaseItemSkeleton key={ key }/>, 2) }
                    </div>
                </div>
            </div>
            <div className={ el('right') }>
                <div className={ el('buttons-block') }>

                </div>
                <div className={ el('price-block') }>
                    <div className={ el('price') }>
                        <Text><Skeleton width={ 100 }/></Text>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseTeaser;
